<div class="w-full flex flex-wrap justify-between items-center rounded-lg p-4 md:!max-w-[500px]">
  <div class="w-full flex items-center justify-between">
    <button class="flex items-center justify-center btn-green-flat w-28 h-10 !text-xs px-2 cursor-pointer"
      (click)="savePicture()" [disabled]="cropping" [appButtonLoader]="cropping">
      ارسال
      <span class="icon crop-regular text-base"></span>
    </button>

    <button class="flex items-center justify-center btn-blue-flat w-28 h-10 !text-xs px-2 cursor-pointer"
      (click)="changeImage()" [disabled]="cropping" [appButtonLoader]="cropping">
      تغییر تصویر
    </button>
  </div>

  <div class="w-full mt-2 flex flex-wrap items-center">
    <div class="w-full md:flex-1 flex justify-between">
      <!-- * Zoom in -->
      <button mat-icon-button (click)="zoomIn()">
        <span class="icon zoom-in-regular text-base"></span>
      </button>
      <!-- * Zoom out -->
      <button mat-icon-button (click)="zoomOut()">
        <span class="icon zoom-out-regular text-base"></span>
      </button>
      <!-- * Rotate left -->
      <button mat-icon-button (click)="rotateLeft()">
        <span class="icon arrow-counterclockwise-filled text-base"></span>
      </button>
      <!-- * Rotate right -->
      <button mat-icon-button (click)="rotateRight()">
        <span class="icon arrow-clockwise-filled text-base"></span>
      </button>
    </div>

    <ng-container *ngIf="config.fromQuote">
      <div class="w-full md:w-1/2 flex items-center justify-end">
        <!-- * Ratio 1:1 -->
        <button class="aspect-[1/1] w-12 text-sm bg-gray-100 dark:bg-gray-800 text-gray-900 !rounded-md"
          (click)="changeAspectRatio(aspectRatioEnum.One_One)">
          1:1
        </button>
        <!-- * Ratio 2:1 -->
        <button class="aspect-[2/1] w-12 text-sm bg-gray-100 dark:bg-gray-800 text-gray-900 !rounded-md mr-2"
          (click)="changeAspectRatio(aspectRatioEnum.Two_One)">
          2:1
        </button>
        <!-- * Ratio 4:5 -->
        <button class="aspect-[4/5] w-12 text-sm bg-gray-100 dark:bg-gray-800 text-gray-900 !rounded-md mr-2"
          (click)="changeAspectRatio(aspectRatioEnum.Four_Five)">
          4:5
        </button>
      </div>
    </ng-container>
  </div>

  <input class="w-full mt-10" type="file" id="fileInput" class="hidden" (change)="fileChangeEvent($event)" />

  <div class="m-auto mt-2 ">

    <image-cropper [roundCropper]="isCircle" [imageChangedEvent]="imageChangedEvent" [transform]="transform"
      format="webp" [aspectRatio]="aspectRatio" [maintainAspectRatio]="isAspectRatioFixed"
      (imageCropped)="imageCropped($event)" (loadImageFailed)="loadImageFailed()">
    </image-cropper>

  </div>
</div>